// Top level Frak Config
window.FrakSetup = {
  config: {
    metadata: {
      name: "Voltaire",
      lang: "fr",
    },
    domain: window.location.host,
    customizations: {
      i18n: {
        "sharing.title":
          "Prêt(e) à partager votre expérience Voltaire et à parrainer vos proches ?",
        "sharing.text":
          "Je t'invite à découvrir l'univers Voltaire et à réserver un essai en boutique. Leurs vélos électriques sont aussi élégants qu'innovants. Avec ce lien, une surprise t’attend ! 🎁",
        "sdk.wallet.login.text":
          "Recevez entre **140€** et **400€** sur votre porte-monnaie par ami(e) qui achète un vélo **Voltaire**!",
      },
    },
  },
  modalConfig: {
    login: {
      allowSso: true,
      ssoMetadata: {
        logoUrl:
          "https://voltaire.bike/cdn/shop/files/Asset_4PANIER_300x.png?v=1718554844",
        homepageLink: "https://voltaire.bike/",
      },
    },
    metadata: {
      header: {
        icon: "https://voltaire.bike/cdn/shop/files/Asset_4PANIER_300x.png?v=1718554844",
      },
      isDismissible: true,
      lang: "fr",
    },
  },
  modalShareConfig: {
    link: window.location.href,
  },
  modalWalletConfig: {
    metadata: {
      logo: "https://voltaire.bike/cdn/shop/files/Voltaire_Logo_Noir.svg",
      homepageLink: "https://voltaire.bike/",
      position: "left",
    },
    loggedIn: {
      action: {
        key: "sharing",
        options: {
          link: window.location.href,
        },
      },
    },
  },
};

// Function to find all the div with the `data-tf-live` attribute
function findTypeformActions() {
  return Array.from(document.querySelectorAll("[data-tf-live]"));
}

// Helper to watch on the wallet status and then execute a callback
onFrakClientReady(() => {
  if (!window.FrakSetup?.client) {
    console.warn("Frak Client not found");
    return;
  }

  // Watch the wallet status and add an hidden field to the typeforms
  FrakSDK.watchWalletStatus(window.FrakSetup?.client, (status) => {
    // Update every typeform action
    const actions = findTypeformActions();
    for (const action of actions) {
      setWalletStatusOnAction(action, status.wallet);
    }

    // Then reload the typeform
    window.tf?.reload();
  });
});

/**
 * Set the wallet status on the typeform action
 * @param action
 * @param wallet
 */
function setWalletStatusOnAction(action, wallet) {
  // Set the hidden fields on the action and the button
  action.setAttribute(
    "data-tf-hidden",
    getTypeformHiddenFields(action, wallet)
  );

  // Get the btn below the action
  const btn = action.querySelector("button");
  if (btn) {
    btn.setAttribute("data-tf-hidden", getTypeformHiddenFields(action, wallet));
  }
}

function getTypeformHiddenFields(component, wallet) {
  const hiddenFields = component.getAttribute("data-tf-hidden") ?? "";
  return hiddenFields
    .split(",")
    .filter((field) => field)
    .filter((field) => !field.startsWith("frak_wallet="))
    .concat(`frak_wallet=${wallet}`)
    .join(",");
}

// Listen when the page is rdy (and thus probably contain the FrakClient)
function onDocumentReady(callback) {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    setTimeout(callback, 1);
  } else if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    // @ts-ignore
    document.attachEvent("onreadystatechange", () => {
      if (document.readyState === "complete") {
        callback();
      }
    });
  }
}

// Listen when the FrakClient is rdy
function onFrakClientReady(callback) {
  // The FrakClient can only be rdy when the document is ready
  onDocumentReady(() => {
    // Check if we already have a client, if yes, directly execute the callback
    if (window.FrakSetup?.client) {
      callback();
      return;
    }
    // Add a listener for when the Frak client is ready
    window.addEventListener("frakClientReady", callback, false);
  });
}
